<template>
    <div class="page" data-cy="container_pdpa_page">
        <div class="page-content" data-cy="container_pdpa_content">
            <PdpaContent
                :type="type"
                :localeCode="localeCode"
                @onError="onError($event)"
                data-cy="component_pdpa_content" />
        </div>
        <div class="page-bg" data-cy="container_pdpa_background"></div>
    </div>
</template>
<script>
// mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
// component
import PdpaContent from '@/components/Authen/Pdpa/PdpaContent.vue';
export default {
    name: 'Pdpa',
    mixins: [LocaleMixin, ModalMixin],
    components: {
        PdpaContent
    },
    data: function () {
        return {
            type: 'terms'
        };
    },
    created: function () {
        this.type = this.$route.name;
    },
    methods: {
        onError: function (error) {
            this.errorApi(error);
        }
    }
}
</script>